import { useAuth, ROLES } from '../../contexts/AuthContext';
import { usePerspective } from '../../contexts/PerspectiveContext';
import CommandCenterDashboard from './CommandCenterDashboard';
import ConsultantClientDashboard from '../consultant/ConsultantClientDashboard';

// Role-based dashboard routing
// Consultant: Multi-client portfolio dashboard with context switching
// Contractor Admin/Bid Manager: Unified Command Center
// Super Admin: Global view (or Consultant view when in mock mode)
export default function DashboardRouter() {
  const { user } = useAuth();
  const { getEffectiveRole, isInMockView } = usePerspective();
  
  const effectiveRole = getEffectiveRole();
  
  // Consultants get the multi-client portfolio dashboard
  // Super Admin in Consultant mock view also gets this dashboard
  if (effectiveRole === ROLES.CONSULTANT || effectiveRole === ROLES.CONSULTANT_ASSOCIATE) {
    return <ConsultantClientDashboard />;
  }
  
  // All other roles use the unified Command Center Dashboard
  return <CommandCenterDashboard />;
}
